<template>
    <div>
        <v-boilerplate
                type="list-item"
                v-for="idx in itemsCount"
                :key="idx"
                transition="transition-fade"
                :boilerplate="false"
        ></v-boilerplate>
    </div>
</template>

<script>
    export default {
        name: "CategoriesSidebarSkeleton",
        components:{
            VBoilerplate: {
                functional: true,

                render (h, { data, props, children }) {
                    return h('v-skeleton-loader', {
                        ...data,
                        props: {
                            boilerplate: true,
                            elevation: 2,
                            ...props,
                        },
                    }, children)
                },
            }
        },
        data(){
            return {
                itemsCount: 7
            }
        }
    }
</script>

<style scoped>

</style>
